/**
 * Removes occurrences of the keyword "SELECT", "Select", or "select" from a given string.
 *
 * @param value - The input string from which the keyword is to be removed.
 * @returns The input string with occurrences of the keyword removed.
 */
export default function removeSelectKeyword(value: any): any {
  if (value === null || typeof value !== 'string') {
    return value;
  }
  return value.replace(/select/ig, '');
}
